import React from "react";

import { Route } from "react-router-dom";

import { StreamsApiProvider } from "./hooks/api";

const LazyStreamsListPage = React.lazy(
  () => import("./components/StreamsList")
);
const LazyStreamDetailsPage = React.lazy(
  () => import("./components/StreamDetails")
);
const LazyStreamCreatePage = React.lazy(
  () => import("./components/StreamCreate")
);

export const routes = (
  <>
    <Route index element={<LazyStreamsListPage />} />
    <Route path="create" element={<LazyStreamCreatePage />} />
    <Route path=":streamId" element={<LazyStreamDetailsPage />} />
  </>
);

export { StreamsApiProvider };
